// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Ao-z","breadcrumbForward":"Bo-z","breadcrumbBack":"Co-z","selected":"Do-z"};